import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ResponseSuccess } from '../../types.tsx';

export const fetchData = (key: string): Promise<ResponseSuccess> => {
	const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
	return performGetRequest(requestUrl);
};
